export enum FailReason {
  Revealed = 'revealed',
  Incorrect = 'incorrect',
  Skipped = 'skipped',
  Null = null,
}
export interface KnowledgeProgressTracker {
  conceptId: string; // id if exits
  concept: string; // Text of the concept
  conceptType: string; // Some have concept may repease. for polilan is verbs and words.
  conceptPath: string; // to have better control example 'ja.words.warui'
  learningActivity: string; // flashcard, quiz, etc.
  activityId: string; // Optional, some activitivies may have id.
  success: boolean;
  points: number; // this progress can return points.
  revealed?: boolean; // Not sure of this , just for now to see how vocabularies works
  completed?: boolean; // Not sure of this , just for now to see how vocabularies works
  justCompleted?: boolean; // Not sure of this , just for now to see how vocabularies works
  createdAt: Date; // date of the action
  failReason?: FailReason; // Optional
}

export enum ConceptStatus {
  AlreadyKnown = 'alreadyKnown',
  Learning = 'learning',
  Learned = 'learned',
  NotSelected = 'notSelected',
  NotEncountered = null,
}

export interface KnowledgeUserState {
  conceptId: string;
  concept: string;
  conceptType: string; // words, lessons, etc.
  conceptPath: string;
  status: ConceptStatus; // alreadyKnown, learning, learned, notSelected, notEncountered
  level?: number; // Difficulty level
  firstTimeEncountered?: Date;
  lastPracticed?: Date;
  learnedDate?: Date;
  tags?: Array<string>; // add some tags.
  // relatedConcepts?: Array<{ conceptId: string; relationshipType: string }>; // planning for future, may be not in user but general graph
  nextReviewTime?: Date;

  stats: {
    progress: number; // 0 to 100
    totalReviews: number;
    successCount: number;
    failedCount: number;
    totalTimeSpent: number; // Not sure how to measure this.
    // considering add streak for future.
  };
}
